import { computed, ref, watch } from 'vue'
import { defineStore, storeToRefs } from 'pinia'
import { ENewsTypeReverse } from '@/lib/references'
import { useWaitingNewsStore } from '@/ContextTab/stores/newsSet/task-panel/waiting'
import { useInProgressNewsStore } from '@/ContextTab/stores/newsSet/task-panel/inProgress'
import { usePredicates } from '@/ContextTab/stores/newsSet/usePredicates'
import type { NewsItemPublished } from '@/ContextTab/stores/types'


export const useNewsCountersStore = defineStore('newsCounters', () => {

  const { checkIsMine } = usePredicates()

  const {
    newsList: waitingNews,
    isFetching: isFetchingWaiting,
  } = storeToRefs(useWaitingNewsStore())

  const {
    newsList: inProgressNews,
    isFetching: isFetchingInProgress,
  } = storeToRefs(useInProgressNewsStore())

  // в счетчиках не должны учитываться новости одногруппников, только свои
  const myInProgressNews = computed(() => inProgressNews.value.filter(checkIsMine))

  const waitingFlashCount = ref(0)
  const waitingExpressCount = ref(0)
  const waitingNotUrgentCount = ref(0)

  const inProgressFlashCount = ref(0)
  const inProgressExpressCount = ref(0)
  const inProgressNotUrgentCount = ref(0)


  function isFlash(newsItem: NewsItemPublished) {
    return newsItem.version?.type_id === ENewsTypeReverse.FLASH
  }

  function isExpress(newsItem: NewsItemPublished) {
    return newsItem.version?.type_id === ENewsTypeReverse.EXPRESS
  }

  function recalcCounters(news: NewsItemPublished[]) {
    const counters = { flash: 0, express: 0, other: 0 }
    news.forEach((newsItem) => {
      if (isFlash(newsItem)) {
        counters.flash++
      } else if (isExpress(newsItem)) {
        counters.express++
      } else {
        counters.other++
      }
    })
    return counters
  }

  watch(waitingNews, () => {
    const counters = recalcCounters(waitingNews.value)
    waitingFlashCount.value = counters.flash
    waitingExpressCount.value = counters.express
    waitingNotUrgentCount.value = counters.other
  })

  watch(myInProgressNews, () => {
    const counters = recalcCounters(myInProgressNews.value)
    inProgressFlashCount.value = counters.flash
    inProgressExpressCount.value = counters.express
    inProgressNotUrgentCount.value = counters.other
  })

  return {
    waitingFlashCount,
    waitingExpressCount,
    waitingNotUrgentCount,
    isFetchingWaiting,
    inProgressFlashCount,
    inProgressExpressCount,
    inProgressNotUrgentCount,
    isFetchingInProgress,
  }
})
